import React from 'react';

const SearchInput = React.forwardRef<HTMLInputElement, React.HTMLProps<HTMLInputElement>>(function Search(props, ref) {
  const { className, ...inputProps } = props;
  const inputClassName = className ? `search-input__elm ${className}` : 'search-input__elm';

  return (
    <div className="search-input__wrapper">
      <div className="search-input__inner-wrapper">
        <input ref={ref} className={inputClassName} {...inputProps} />
      </div>
    </div>
  );
});

export default SearchInput;
